import { render, staticRenderFns } from "./Sinavlar.vue?vue&type=template&id=9233874e&"
import script from "./Sinavlar.vue?vue&type=script&lang=js&"
export * from "./Sinavlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports